import { Box } from '@mui/material'
import React from 'react'
import { usePatientFormI18n } from '../utils/patientFormI18n'
import CommunicationReceiver from './CommunicationReceiver'
import {
  PatientCheckbox,
  PatientFieldHint,
  PatientFormCell,
  PatientInlineAddButton,
  PatientSectionTitle,
} from './PatientFormPrimitives'

/** Admin-only routing switches (support portal) plus the extra recipient cards. */
export const PatientCommunicationToPref = ({
  communicationToPref = {},
  onPreferenceChange,
  onAddReceiver,
  onUpdateReceiver,
  onRemoveReceiver,
  editMode = true,
  validationHook,
}) => {
  const { copy } = usePatientFormI18n()
  const {
    toPatient = true,
    toAttendant = true,
    toOthers = true,
    receivers = [],
  } = communicationToPref || {}

  const toggle = (field) => (event) => {
    if (editMode && onPreferenceChange) {
      onPreferenceChange(field, event.target.checked)
    }
  }

  return (
    <>
      <PatientFormCell span={12}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '10px 24px' }}>
          <PatientCheckbox
            id="patient-comm-to-patient"
            label={copy.sendToPatientLabel}
            checked={toPatient}
            onChange={toggle('toPatient')}
            disabled={!editMode}
          />
          <PatientCheckbox
            id="patient-comm-to-attendant"
            label={copy.sendToAttendantLabel}
            checked={toAttendant}
            onChange={toggle('toAttendant')}
            disabled={!editMode}
          />
          <PatientCheckbox
            id="patient-comm-to-others"
            label={copy.sendToOthersLabel}
            checked={toOthers}
            onChange={toggle('toOthers')}
            disabled={!editMode}
          />
        </Box>
      </PatientFormCell>

      {toOthers && (
        <PatientFormCell span={12}>
          <PatientSectionTitle
            action={
              editMode && onAddReceiver ? (
                <PatientInlineAddButton onClick={onAddReceiver}>
                  {copy.addRecipientButton}
                </PatientInlineAddButton>
              ) : null
            }
          >
            {copy.additionalRecipientsTitle}
          </PatientSectionTitle>

          {receivers.length === 0 ? (
            <PatientFieldHint sx={{ marginTop: '6px' }}>
              {copy.additionalRecipientsEmpty}
              {editMode ? ` ${copy.additionalRecipientsHint}` : ''}
            </PatientFieldHint>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '6px' }}>
              {receivers.map((receiver, index) => (
                <CommunicationReceiver
                  key={index}
                  receiver={receiver}
                  index={index}
                  onUpdate={onUpdateReceiver}
                  onRemove={onRemoveReceiver}
                  editMode={editMode}
                  validationHook={validationHook}
                />
              ))}
            </Box>
          )}
        </PatientFormCell>
      )}
    </>
  )
}

export default PatientCommunicationToPref
